import React, { FC, PropsWithChildren } from 'react';

import { Root } from './index.styled';

interface Props extends PropsWithChildren {
  background?: boolean;
}

const StringOutput: FC<Props> = ({ children, background }) => {
  return (
    <Root>
      <div className={background ? 'background' : ''}>{children}</div>
    </Root>
  );
};

export { StringOutput };